import { z } from 'zod'

// Shared metrics shape — used by both Route and Track.
//
// Route interprets `duration_seconds` as estimated time;
// Track interprets it as actual recorded duration.

export const Metrics = z.object({
  distance_km: z.number().nonnegative().optional(),
  ascent_m: z.number().nonnegative().optional(),
  descent_m: z.number().nonnegative().optional(),
  duration_seconds: z.number().nonnegative().optional(),
  point_count: z.number().int().nonnegative().optional(),
})
export type Metrics = z.infer<typeof Metrics>
